enum ImageAspectRatio {
  HD_16X9 = 16 / 9,
  HD_3X1 = 3 / 1,
  SQUARE_1X1 = 1,
  HD_24X10 = 24 / 10,
  HD_3X2 = 3 / 2,
}

export default ImageAspectRatio;
